import { Button, message, Popover, Table } from "antd";
import { formatDateTimeSeconds } from "~/utils/dateUtils";
import { useEffect, useState } from "react";
import { FaTrash } from "react-icons/fa6";
import { RxAvatar } from "react-icons/rx";
import styled from "styled-components";
import { InvitationAPIs, remote_getOrganizationPendingInvitations } from "~/common/typescript/apis/InvitationAPIs";
import { OrganizationAPIs } from "~/common/typescript/apis/OrganizationAPIs";
import UserAvatar from "~/layouts/components/Header/components/UserAvatar/UserAvatar";
import OrganizationRoleTag from "~/components/app_common/OrganizationRoleTag/OrganizationRoleTag";

interface OrgInvitationListProps {
  organizationID?: string;
}
const OrgInvitationList = (props: OrgInvitationListProps) => {
  const [invitations, setInvitations] = useState<any[]>([]);
  const [deletingId, setDeletingId] = useState<number | null>(null);

  const handleDeleteInvitation = async (invitationId: number) => {
    try {
      setDeletingId(invitationId);
      await InvitationAPIs.remote_deleteInvitation(invitationId);
      message.success('Xóa lời mời thành công');
      fetchData();
    } catch (error) {
      console.error('Error deleting invitation:', error);
      message.error('Xóa lời mời thất bại');
    } finally {
      setDeletingId(null);
    }
  };
  const columns = [
    {
      title: <RxAvatar style={{ width: '24px', height: '24px' }} />,
      dataIndex: 'user',
      key: 'user',
      render: (text: any, record: any) => (
        <div>
          <UserAvatar user={record.to} />
        </div>
      ),
    },
    {
      title: 'Số điện thoại',
      dataIndex: 'user',
      key: 'user',
      render: (text: any, record: any) => (
        <div>
          {record.to?.username}
        </div>
      ),
    },
    {
      title: 'Email',
      dataIndex: 'user',
      key: 'user',
      render: (text: any, record: any) => (
        <div>
          {record.to?.email}
        </div>
      ),
    },
    {
      title: 'Vai trò',
      dataIndex: 'role',
      key: 'role',
      render: (text: any, record: any) => (
        <OrganizationRoleTag role={record.role} />
      ),
    },
    {
      title: 'Thời gian',
      dataIndex: 'role',
      key: 'role',
      render: (text: any, record: any) => (
        <div>{formatDateTimeSeconds(record.createdAt)}</div>
      ),
    },
    {
      title: 'Công cụ',
      dataIndex: 'role',
      key: 'role',
      render: (text: any, record: any) => (
        <div>
          <Popover
            content={
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div>Bạn có chắc muốn xóa lời mời này?</div>
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                  <Button size="small">Hủy</Button>
                  <Button
                    size="small"
                    type="primary"
                    danger
                    loading={deletingId === record.id}
                    onClick={() => handleDeleteInvitation(record.id)}
                  >
                    Xóa
                  </Button>
                </div>
              </div>
            }
            title="Xác nhận xóa"
            trigger="click"
          >
            <Button
              type="primary"
              danger
              style={{ padding: 2, width: 30 }}
              loading={deletingId === record.id}
            >
              <FaTrash size={12} />
            </Button>
          </Popover>
        </div>
      ),
    },
  ];
  const fetchData = async () => {
    InvitationAPIs.remote_getOrganizationPendingInvitations({ organizationId: Number(props.organizationID) }).then((response) => {
      setInvitations(response);
      console.log('response', response);
    });
  }
  useEffect(() => {
    if (!props.organizationID) return;
    fetchData();
  }, [props.organizationID]);

  if (!props.organizationID) {
    return null;
  }
  return (
    <UI_Wrapper>
      <UI_Title>Danh sách lời mời</UI_Title>
      <Table columns={columns} dataSource={invitations} />
    </UI_Wrapper>
  )
}

export default OrgInvitationList;

const UI_Wrapper = styled.div`
`;

const UI_Title = styled.div`
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
`;

const UI_Invitation_Wrapper = styled.div`
`;